module.exports = __webpack_public_path__ + "img/retailITwo.8f61616a.jpg";